 import './_language.js';

window.addEventListener("load", function () {
    const btnBurger = document.querySelector('#totalfootball-ld-26-cb-navigation .btn-burger');
    const dropdownMenu = document.querySelector('#totalfootball-ld-26-cb-navigation .dropdown-menu');
    const languageInput = document.querySelector('#totalfootball-ld-26-cb-navigation #language');
    const languageContainer = document.querySelector('#totalfootball-ld-26-cb-navigation .language');
    
    if (btnBurger && dropdownMenu) {
        btnBurger.addEventListener('click', function() {
            dropdownMenu.classList.toggle('active');
        });
    }

    // Đóng language dropdown khi click ra ngoài trên PC
    if (languageInput && languageContainer) {
        // Ngăn click bên trong container bubble ra ngoài
        languageContainer.addEventListener('click', function(event) {
            event.stopPropagation();
        });

        // Đóng dropdown khi click ra ngoài
        document.addEventListener('click', function(event) {
            if (languageInput.checked) {
                languageInput.checked = false;
            }
        });
    }
});

